module.exports = __webpack_public_path__ + "img/dpa-check.fe13302e.svg";